export default "__VITE_ASSET__511005ea__"